export const BRAND_NAME = 'Workcrafted';
export const BRAND_DESCRIPTOR = 'Custom Systems & Automation';
export const CASE_STUDY_DISCLAIMER = 'Case studies are anonymized. Client names, product names, and identifying details are withheld. All interface imagery uses fictional, representative data.';
